/* eslint no-underscore-dangle: 0 -- underscore */
import { loadCustomLangPack } from '../ducks/tenancyLocale';
import { moduleName } from '../constants';

/* istanbul ignore next  -- ignore */
if (process.env.TEST_ENV && process.env.TEST_ENV === 'test') {
  require.ensure = (_deps, cb) => cb(require);
}

const loadCustomLocaleData = (locale) => {
  require.ensure([], (require) => {
    // eslint-disable-next-line import/no-dynamic-require -- dynamic require is needed here
    const localeData = require(`../../customLocaleData/${locale}.json`);
    global.IntlPolyfill.__addLocaleData(localeData);
  });
};

const queryCustomIntlData = (locale) => (dispatch, getState) => {
  const loadedLocales = getState().getIn(
    ['modules', moduleName, 'tenancyLocale', 'loadedCustomLangPackLocales']
  ).toJS();
  if (!loadedLocales.includes(locale)) {
    loadCustomLocaleData(locale);
    dispatch(loadCustomLangPack(locale));
  }
  return { status: 'complete', data: {}, promise: Promise.resolve({}) };
};

export {
  queryCustomIntlData,
  loadCustomLocaleData,
};
